import Story from "../../../Common/assets/svg/story.svg";
import Bug from "../../../Common/assets/svg/bug.svg";
import Feature from "../../../Common/assets/svg/feature.svg";
import Improvement from "../../../Common/assets/svg/improvement.svg";
import Precondition from "../../../Common/assets/svg/precondition.png";
import Risk from "../../../Common/assets/svg/risk.svg";
import Spike from "../../../Common/assets/svg/spike.svg";
import Task from "../../../Common/assets/svg/task.svg";
import TechnicalDebt from "../../../Common/assets/svg/technical-debt.svg";
import Test from "../../../Common/assets/svg/test.png";
import TestExecution from "../../../Common/assets/svg/test-execution.png";
import TestPlan from "../../../Common/assets/svg/test-plan.png";
import TestSet from "../../../Common/assets/svg/test-set.png";
import StoryDefect from "../../../Common/assets/svg/story-defect.svg";
import SubTask from "../../../Common/assets/svg/sub-task.svg";
import SubTestExecution from "../../../Common/assets/svg/sub-test-execution.png";
import Incident from "../../../Common/assets/svg/incident.svg";
import UserStory from "../../../Common/assets/svg/user-story.svg";
import GeneralDefect from "../../../Common/assets/svg/general-defect.svg";
import Experiment from "../../../Common/assets/svg/experiment.svg";
import Deliverable from "../../../Common/assets/svg/deliverable.svg";
import Epics from "../../../Common/assets/svg/epics.svg";
import Theme from "../../../Common/assets/svg/theme.svg";
import Epic from "../../../Common/assets/svg/epic.svg";
import Design from "../../../Common/assets/svg/design.svg";

export const JiraIssueTypeIconMap: Record<string, string> = {
  Story: Story,
  Bug: Bug,
  Feature: Feature,
  Improvement: Improvement,
  Precondition: Precondition,
  Risk: Risk,
  Spike: Spike,
  Task: Task,
  "Technical Debt": TechnicalDebt,
  Test: Test,
  "Test Execution": TestExecution,
  "Test Plan": TestPlan,
  "Test Set": TestSet,
  "Story Defect": StoryDefect,
  "Sub-task": SubTask,
  "Sub Test Execution": SubTestExecution,
  Incident: Incident,
  "User story": UserStory,
  "General Defect": GeneralDefect,
  Experiment: Experiment,
  Deliverable: Deliverable,
  Epics: Epics,
  Theme: Theme,
  Epic: Epic,
  Design: Design,
};
